"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _i18n = require("../i18n");

var _reactI18next = require("react-i18next");

var _coamClient = require("coam-client");

var _reactComponents = require("@cimpress/react-components");

var _Loading = _interopRequireDefault(require("./common/Loading"));

var _ErrorInfo = _interopRequireDefault(require("./common/ErrorInfo"));

var _debounce = _interopRequireDefault(require("debounce"));

var _UserLine = _interopRequireDefault(require("./UserLine"));

var _reactStreamlineIcons = require("@cimpress-technology/react-streamline-icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var UserForm =
/*#__PURE__*/
function (_React$Component) {
  _inherits(UserForm, _React$Component);

  function UserForm(props) {
    var _this;

    _classCallCheck(this, UserForm);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UserForm).call(this, props));
    _this.state = {
      editUserRolesModalOpen: false,
      editUser: undefined,
      searchKey: '',
      currentRoles: _this.props.user ? _this.props.user.roles : [],
      isAdmin: _this.props.user ? _this.props.user.is_admin : false
    };
    _this.debouncedSearch = (0, _debounce.default)(_this.searchPrincipals, 500);
    return _this;
  }

  _createClass(UserForm, [{
    key: "tt",
    value: function tt(key) {
      var _this$props = this.props,
          t = _this$props.t,
          language = _this$props.language;
      return t(key, {
        lng: language
      });
    }
  }, {
    key: "executeRequest",
    value: function executeRequest(promise, caption, stateVar) {
      var _this2 = this;

      this.setState({
        isExecutingRequest: true,
        executingRequestCaption: caption
      });
      return promise.then(function (response) {
        var state = {
          isExecutingRequest: false
        };

        if (stateVar) {
          state[stateVar] = response;
        }

        _this2.setState(state);
      }).catch(function (error) {
        _this2.setState({
          isExecutingRequest: false,
          executingRequestError: error
        });
      });
    }
  }, {
    key: "searchPrincipals",
    value: function searchPrincipals() {
      return this.executeRequest((0, _coamClient.findPrincipals)(this.props.accessToken, this.state.searchKey), this.tt('searching'), 'foundPrincipals');
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;

      if (prevProps.accessToken !== this.props.accessToken && this.props.accessToken) {
        this.fetchGroupInfo().then(function () {
          return _this3.fetchRoles();
        });
      }

      if (JSON.stringify(prevProps.user) !== JSON.stringify(this.props.user)) {
        this.setState({
          currentRoles: this.props.user ? this.props.user.roles : []
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.accessToken) {
        return;
      }
    }
  }, {
    key: "renderUserRow",
    value: function renderUserRow(user, onClick) {
      return _react.default.createElement("tr", null, _react.default.createElement("td", {
        className: 'rcu-user-row',
        onClick: onClick
      }, _react.default.createElement(_UserLine.default, {
        language: this.props.language,
        withUserType: false,
        user: user,
        withAvatar: this.props.showAvatar,
        withEmail: this.props.showEmail,
        withName: this.props.showName
      })));
    }
  }, {
    key: "renderSearch",
    value: function renderSearch() {
      var _this4 = this;

      return [_react.default.createElement("div", {
        key: 0,
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-sm-12"
      }, _react.default.createElement(_reactComponents.TextField, {
        autoFocus: true,
        label: this.tt('search_for_users'),
        value: this.state.searchKey,
        onChange: function onChange(v) {
          _this4.setState({
            searchKey: v.target.value
          }, function () {
            return _this4.debouncedSearch();
          });
        }
      }))), _react.default.createElement("div", {
        key: 1,
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-sm-12"
      }, _react.default.createElement("div", null, this.state.isExecutingRequest ? _react.default.createElement(_Loading.default, {
        language: this.props.language
      }) : _react.default.createElement("table", {
        className: "table table-hover"
      }, _react.default.createElement("tbody", null, this.state.foundPrincipals && this.state.foundPrincipals.length === 0 ? _react.default.createElement("tr", null, _react.default.createElement("td", null, this.tt('no_users_found'))) : (this.state.foundPrincipals || []).map(function (p) {
        return _this4.renderUserRow(p.profile ? p.profile : p, function () {
          return _this4.setState({
            selectedUser: p
          });
        });
      }))))))];
    }
  }, {
    key: "onToggleRole",
    value: function onToggleRole(roleName, isRoleAssigned) {
      var newRolesList = this.state.currentRoles.slice().filter(function (r) {
        return r !== roleName;
      });

      if (!isRoleAssigned) {
        newRolesList.push(roleName);
      }

      this.setState({
        currentRoles: newRolesList
      });
    }
  }, {
    key: "getChangedRoles",
    value: function getChangedRoles() {
      var _this5 = this;

      if (!this.props.user) {
        return {
          'add': this.state.currentRoles
        };
      }

      return {
        'add': this.state.currentRoles.filter(function (a) {
          return _this5.props.user.roles.indexOf(a) === -1;
        }),
        'remove': this.props.user.roles.filter(function (a) {
          return _this5.state.currentRoles.indexOf(a) === -1;
        })
      };
    }
  }, {
    key: "renderRolesSelections",
    value: function renderRolesSelections() {
      var _this6 = this;

      if (this.props.mutuallyExclusiveRoles) {
        var selected = undefined;
        this.props.allowedRoles.forEach(function (x, i) {
          if (_this6.state.currentRoles.indexOf(x.roleName) !== -1) {
            selected = x.roleName;
          }
        });
        return _react.default.createElement("div", null, _react.default.createElement("form", null, _react.default.createElement(_reactComponents.RadioGroup, {
          defaultSelected: selected,
          onChange: function onChange(e, v) {
            return _this6.setState({
              currentRoles: [v]
            });
          }
        }, this.props.allowedRoles.map(function (x, i) {
          return _react.default.createElement(_reactComponents.Radio, {
            key: i,
            className: 'rcu-radio',
            label: _react.default.createElement("h5", null, x.roleCaption || x.roleName),
            value: x.roleName
          });
        }))));
      }

      return this.props.allowedRoles.map(function (x, i) {
        var isRoleAssigned = _this6.state.currentRoles.indexOf(x.roleName) !== -1;
        return _react.default.createElement("div", {
          key: i,
          className: 'clearfix rcu-checkbox-row',
          onClick: function onClick() {
            return _this6.onToggleRole(x.roleName, isRoleAssigned);
          }
        }, _react.default.createElement(_reactComponents.Checkbox, {
          label: _react.default.createElement("h5", {
            style: {
              display: 'inline'
            }
          }, x.roleCaption || x.roleName),
          checked: isRoleAssigned,
          onChange: function onChange(e) {
            e.stopPropagation();

            _this6.onToggleRole(x.roleName, isRoleAssigned);
          }
        }));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      if (this.state.executingRequestError) {
        return _react.default.createElement(_ErrorInfo.default, {
          language: this.props.language,
          error: this.state.executingRequestError,
          onAcknowledgeClick: function onAcknowledgeClick() {
            _this7.setState({
              executingRequestError: undefined
            });
          }
        });
      }

      if (!this.props.accessToken) {
        return _react.default.createElement(_Loading.default, {
          language: this.props.language,
          message: this.tt('initializing')
        });
      }

      if (!this.state.selectedUser && !this.props.user) {
        return _react.default.createElement("div", null, this.renderSearch(), _react.default.createElement("div", {
          align: "right"
        }, _react.default.createElement("button", {
          className: 'btn btn-default',
          onClick: function onClick() {
            return _this7.props.onCancel();
          }
        }, this.tt('button_cancel'))));
      }

      var user = this.state.selectedUser || this.props.user;
      return _react.default.createElement("div", null, _react.default.createElement("table", {
        className: "table table-hover"
      }, _react.default.createElement("tbody", null, this.renderUserRow(user, this.props.user ? null : function () {
        return _this7.setState({
          selectedUser: undefined
        });
      }))), _react.default.createElement("div", {
        className: 'rcu-checkbox-list'
      }, this.renderRolesSelections(), _react.default.createElement("div", {
        className: 'clearfix rcu-checkbox-row',
        onClick: function onClick() {
          return _this7.setState({
            isAdmin: !_this7.state.isAdmin
          });
        }
      }, _react.default.createElement(_reactComponents.Checkbox, {
        inline: true,
        label: _react.default.createElement("h5", {
          className: 'text-warning',
          style: {
            display: 'inline'
          }
        }, this.tt('group_administrator')),
        checked: this.state.isAdmin,
        onChange: function onChange(e) {
          e.stopPropagation();

          _this7.setState({
            isAdmin: !_this7.state.isAdmin
          });
        }
      }), _react.default.createElement("div", {
        className: 'pull-right'
      }, _react.default.createElement(_reactComponents.Tooltip, {
        contents: this.tt('group_administrator_context_help')
      }, _react.default.createElement("span", {
        className: 'rcu-info-icon'
      }, _react.default.createElement(_reactStreamlineIcons.IconInformationCircle, {
        size: 'lg'
      })))))), _react.default.createElement("div", {
        align: "right"
      }, _react.default.createElement("button", {
        className: 'btn btn-default',
        onClick: function onClick() {
          return _this7.props.onCancel();
        }
      }, this.tt('button_cancel')), "\xA0", _react.default.createElement("button", {
        className: 'btn btn-primary',
        onClick: function onClick() {
          return _this7.props.onConfirm(user, _this7.getChangedRoles(), _this7.state.isAdmin);
        }
      }, this.tt('button_confirm'))));
    }
  }]);

  return UserForm;
}(_react.default.Component);

UserForm.propTypes = {
  // silence eslint
  t: _propTypes.default.any,
  i18n: _propTypes.default.any,
  language: _propTypes.default.string,
  user: _propTypes.default.object,
  showAvatar: _propTypes.default.bool,
  showEmail: _propTypes.default.bool,
  showName: _propTypes.default.bool,
  accessToken: _propTypes.default.string,
  // roles to allow to assign to
  allowedRoles: _propTypes.default.array.isRequired,
  mutuallyExclusiveRoles: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  onCancel: _propTypes.default.func,
  onConfirm: _propTypes.default.func
};
UserForm.defaultProps = {
  language: 'eng',
  readOnly: false,
  mutuallyExclusiveRoles: false
};

var _default = (0, _reactI18next.translate)('translations', {
  i18n: (0, _i18n.getI18nInstance)()
})(UserForm);

exports.default = _default;